<form (ngSubmit)="onSubmit()" [formGroup]="group">
  <ui-form-text [data]="dataAlias" [formControlName]="dataAlias.name"></ui-form-text>
  <div class="markup-text">
    <p>
      <ui-icon faStyle="light" faName="circle-info"></ui-icon>
      Für einen besseren Überblick können Sie für jede Ihrer Kundennummern einen Namen vergeben z.B. Filiale am Markt o.ä.. Diese Bezeichnung können Sie jederzeit bearbeiten.
    </p>
  </div>
  <ui-form-submit [data]="dataSubmit"></ui-form-submit>
</form>
